import Lottie from "lottie-react";
import styled from "styled-components";

import Loading from "../../consts/Loading.json"
import { memo } from "react";
import { MAIN_COLORS } from "../../consts/colors";

const Wrapper = styled.div`
    position: fixed;
    inset: 0;
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: ${MAIN_COLORS.purple_100};

    > div {
      width: min(72vw, 320px);
      height: min(72vw, 320px);
      flex: none;
    }
`
const Loader = () => {
  return (
    <Wrapper role="status" aria-label="Загрузка">
      <Lottie animationData={Loading}/>
    </Wrapper>
  );
};

export default memo(Loader);
